import { createSlice } from '@reduxjs/toolkit'

export interface ParamsProps {
	params: Object
}

const initialState: ParamsProps = {
	params: {},
}

export const paramsStore = createSlice({
	name: 'paramsStore',
	initialState,
	reducers: {
		setParams: (
			state,
			action: { payload: { [key: string]: string | number | number[] | boolean }; type: Object }
		) => {
			if (Object.keys(action.payload).length === 0) {
				state.params = {}
				return
			}
			if (Object.keys(state.params).length === 0) {
				state.params = action.payload
				return
			} else {
				state.params = { ...state.params, ...action.payload }
				return
			}
		},
		replaceParams: (
			state,
			action: { payload: { [key: string]: string | number | number[] | boolean }; type: Object }
		) => {
			state.params = action.payload
		},
	},
})

export const { setParams, replaceParams } = paramsStore.actions

export default paramsStore.reducer
